import { useFormattedDate } from "../../hooks/useFormattedDate";

const ReportTable = ({ tableData = [] }) => {
  const formattedDate = useFormattedDate();

  if (
    !tableData ||
    tableData?.columns?.length === 0 ||
    tableData?.data?.length === 0
  ) {
    return <p>No data available</p>;
  }

  return (
    <div>
      <table className="w-full border border-gray-300 rounded-lg">
        <thead className="bg-gray-100">
          <tr>
            {tableData?.columns?.map((col, index) => (
              <th
                key={index}
                className="px-4 py-[10px] whitespace-normal break-words border border-gray-300 text-left text-[12px] font-semibold text-gray-700"
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData?.data?.map((row, rowIndex) => (
            <tr key={rowIndex} className="bg-white">
              {tableData?.columns?.map((col, colIndex) => {
                let value = row[col];

                // Handle null/undefined
                if (value === null || value === undefined) {
                  value = "-";
                }

                // Format date fields
                if (col.toLowerCase().includes("date") && value !== "-") {
                  value = formattedDate(value);
                }

                return (
                  <td
                    key={colIndex}
                    className="px-4 py-2 border whitespace-normal break-words border-gray-300 text-[12px] text-gray-600"
                  >
                    {value}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReportTable;
